// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const DurationOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M6 2v20M18 2v20","stroke-width":"2","stroke":"currentColor"}},{"tag":"path","attrs":{"d":"M6 12h12","stroke-dasharray":"2 2","stroke":"currentColor"}}]},"name":"duration","theme":"outlined"};

const DurationOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={DurationOutlinedSvg} />;
  DurationOutlined.displayName = 'DurationOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(DurationOutlined);
